import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { productServices } from '../../Services'

import Loader from '../../Components/Loader'

export const AddProduct = () => {

    const [loader, setLoader] = useState(false)
    const history = useHistory()

    const formik = useFormik({
        initialValues: {
            product_name: '',
            product_gross_weight: '',
            length: '',
            height: '',
            width: '',
        },
        validationSchema: Yup.object({
            product_name: Yup.string().required('Required'),
            product_gross_weight: Yup.string().required('Required'),
            height: Yup.string().required('Required'),
            length: Yup.string().required('Required'),
            width: Yup.string().required('Required')
        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                product_name: values.product_name,
                product_gross_weight: values.product_gross_weight,
                product_dimentions: [{ length: values.length, height: values.height, width: values.width }],
                product_gross_volume: (values.length * values.height * values.width) / 1000000
            }
            productServices.addProduct(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push('/product-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    return (
        <div className="row d-flex justify-content-center">
            <div className="col-lg-7">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="" htmlFor="country currency">Product Name</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.product_name ? !formik.errors.product_name ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('product_name')}
                                            placeholder="Enter Product Name"
                                        />
                                        {formik.touched.product_name && formik.errors.product_name ? (
                                            <div className="text-danger">{formik.errors.product_name}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Product Gross Weight</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.product_gross_weight ? !formik.errors.product_gross_weight ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('product_gross_weight')}
                                            placeholder="Enter Product Gross Weight"
                                            type="number"
                                        />
                                        {formik.touched.product_gross_weight && formik.errors.product_gross_weight ? (
                                            <div className="text-danger">{formik.errors.product_gross_weight}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Product Length</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.length ? !formik.errors.length ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('length')}
                                            placeholder="Enter Product Length"
                                            type="number"
                                        />
                                        {formik.touched.length && formik.errors.length ? (
                                            <div className="text-danger">{formik.errors.length}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Product Height</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.height ? !formik.errors.height ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('height')}
                                            placeholder="Enter Product Height"
                                            type="number"
                                        />
                                        {formik.touched.height && formik.errors.height ? (
                                            <div className="text-danger">{formik.errors.height}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Product Width</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.width ? !formik.errors.width ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('width')}
                                            placeholder="Enter Product Width"
                                            type="number"
                                        />
                                        {formik.touched.width && formik.errors.width ? (
                                            <div className="text-danger">{formik.errors.width}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Product Volume</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.product_volume ? !formik.errors.product_volume ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('product_volume')}
                                            placeholder="Enter Product Volume"
                                            type="number"
                                            defaultValue={formik.values.length * formik.values.height * formik.values.width}
                                            value={(formik.values.length * formik.values.height * formik.values.width) / 1000000}
                                            readOnly
                                        />
                                        {formik.touched.product_volume && formik.errors.product_volume ? (
                                            <div className="text-danger">{formik.errors.product_volume}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="mt-3 d-flex justify-content-between">
                                    <button
                                        className="btn btn-danger w-sm waves-effect waves-light"
                                        type="button"
                                        onClick={() => history.goBack()}
                                    >Back</button>
                                    <button className="btn btn-primary w-sm waves-effect waves-light"
                                        type="button"
                                        onClick={() => formik.handleSubmit()}
                                    >Submit</button>
                                </div>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
